const NOOP = () => {};

let elapsedTime;
let startTime;
let scrollFn;

const easeInOutQuart = (time, start, change, duration) => {
  const progress = time / duration;

  /* eslint-disable no-mixed-operators */
  return progress / 2 < 1
    ? start + change / 2 * progress ** 4
    : start + change / 2 * (2 - (time - 2) ** 4);
};

const startScroll = time => {
  startTime = time;
  scrollFn(time);
}

const scrollToElement = ({ selector, duration = 0, callback = NOOP } = {}) => {
  const target = document.querySelector(selector);

  if (target) {
    const start = window.pageYOffset;
    const distance = target.getBoundingClientRect().top;

    scrollFn = time => {
      elapsedTime = time - startTime;
      window.scrollTo(0, easeInOutQuart(elapsedTime, start, distance, duration));

      if (elapsedTime < duration) {
        window.requestAnimationFrame(scrollFn);
      } else {
        window.scrollTo(0, start + distance);
        callback();
      }
    };

    window.requestAnimationFrame(startScroll);
  }
};

export default scrollToElement;



// WEBPACK FOOTER //
// ./utils/SmoothScroller.js